document.addEventListener('DOMContentLoaded', () => {
  /* ------------------------------------------------------------
     Sélecteurs fixes (markup historique)
  ------------------------------------------------------------ */
  const toc = document.querySelector('[data-article-toc]');
  if (!toc) return;

  const toggleBtn = toc.querySelector('[data-article-toc-toggle]');
  const content = toc.querySelector('[data-article-toc-content]');
  const list = toc.querySelector('[data-article-toc-list]');

  if (!toggleBtn || !content || !list) return;

  /* ------------------------------------------------------------
     Sélecteur EXACT du contenu article (Horizon)
  ------------------------------------------------------------ */
  const articleContent = document.querySelector('.blog-post-content');
  if (!articleContent) {
    toc.remove();
    return;
  }

  /* ------------------------------------------------------------
     Récupération des H2 / H3 uniquement
  ------------------------------------------------------------ */
  const headings = articleContent.querySelectorAll('h2, h3');
  if (!headings.length) {
    toc.remove();
    return;
  }

  /* ------------------------------------------------------------
     Construction de la TOC (optimisée DOM)
  ------------------------------------------------------------ */
  const fragment = document.createDocumentFragment();

  headings.forEach((heading, index) => {
    if (!heading.id) {
      heading.id = heading.textContent
        .toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    }

    const li = document.createElement('li');
    li.className = heading.tagName === 'H3'
      ? 'toc-level-3'
      : 'toc-level-2';

    const a = document.createElement('a');
    a.href = `#${heading.id}`;
    a.textContent = heading.textContent.trim();

    a.addEventListener('click', () => {
      toggleBtn.setAttribute('aria-expanded', 'false');
      content.classList.add('is-collapsed');
    });

    li.appendChild(a);
    fragment.appendChild(li);
  });

  list.appendChild(fragment);

  /* ------------------------------------------------------------
     Toggle ouvrir / fermer (classe is-collapsed)
  ------------------------------------------------------------ */
  toggleBtn.addEventListener('click', () => {
    const isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';

    toggleBtn.setAttribute('aria-expanded', String(!isOpen));
    content.classList.toggle('is-collapsed', isOpen);
  });
});
